import React from 'react';
import { Icon, Popup, PopupContentProps, SemanticShorthandItem } from 'semantic-ui-react';
import './InfoTooltip.scss';

export type InfoTooltipProps = {
  message: string | SemanticShorthandItem<PopupContentProps>;
  size?: 'tiny' | 'mini';
  color?: 'grey' | 'blue';
  on?: 'hover' | 'click';
  trigger?: React.ReactNode;
  hoverable?: boolean;
};

export default function InfoTooltip({ message, size = 'tiny', color = 'grey', on = 'hover', trigger, hoverable }: InfoTooltipProps) {
  return (
    <Popup
      offset={[-12, 0]}
      content={message}
      trigger={trigger || <Icon className="info-tooltip-icon" circular inverted color={color} name="info" size={size} />}
      on={on}
      hoverable={hoverable}
    />
  );
}
